<template>
<div>
	 <el-backtop >
		<div class="to_backtop">
			<i class="el-icon-top"></i>
		</div>
	 </el-backtop>
	<article v-if="isval" class="msg_box">
		<div class="box_aqa">
			<h3>很抱歉，您查看的商品找不到了！</h3>
			<div class="aqa_zi">
				<p>您可以:</p>
				<div>1.检查刚才的输入</div>
				<div>2.去其他地方逛逛：<span class="lan" @click="xin.goUrl('/index')">首页</span></div>
			</div>
		</div>
	</article>
	<main v-else v-loading="loading" class="min_he400 msg_box">
		<nav class="arrow_box clearfloat">
				<span class="arrow_ywz">您的位置：</span>
				<div class="arrow">
					<span class="to" @click="xin.goUrl('/index')">首页</span>
					<span class="el-icon-arrow-right"></span>
					<span class="to" @click="xin.goUrl('/product')">产品中心</span>
					<span class="el-icon-arrow-right"></span>
					<span class="to" @click="xin.goUrl('/oneDetails?cid='+category.id)">{{category.title}}</span>
					<span class="el-icon-arrow-right"></span>
					<span class="topc">{{goods.title}}</span>
				</div>
		</nav>
		<section v-if="!loading" class="goods_box clearfloat">
			<!-- 产品信息 -->
			<aside class="goods_left flo_lf">
				<div class="clearfloat">
					<span class="goods_title flo_lf">{{goods.title}}</span>
					<span class="lan flo_right">货号：{{goods.model}}</span>
				</div>
				<div class="goods_intro">
					{{goods.subtitle}}
				</div>
				<div class="goods_intro">
					{{goods.subtitle_e}}
				</div>
				<div class="laing_btn" @click="ismsg=!ismsg">商品信息</div>
				<div class="goods_list" v-show="ismsg">
					<div class="goods_li" v-if="goods.storage">
						<span class="li_left w1">储存条件：</span>{{goods.storage}}
					</div>
					<div class="goods_li" v-if="goods.transportation">
						<span class="li_left w1" >运输条件：</span>{{goods.transportation}}
					</div>
					<div class="goods_li clearfloat" v-if="goods.formula">
						<span class="li_left w3 ">分子式：</span><div class="htmlsss" v-html="goods.formula"></div>
					</div>
					<div class="goods_li" v-if="goods.formula_weight">
						<span class="li_left w3">分子量：</span><div class="htmlsss" v-html="goods.formula_weight"></div>
					</div>
				</div>
				<!-- 说明书下载 v-if="spce_type==2"-->
				<div class="goods_download">
					<div class="goods_dow" v-for="(itme,i) in goods.other" :key="i">
						<span class="iconfont icon-danganziliao" @click="xin.goNew(itme.file)">{{itme.title}}</span>
					</div>
				</div>
				<div class="goods_select clearfloat"  v-if="goodsSku[skuIndex]">
					<div class="goods_lie flo_lf">选择数量：</div>
					<!-- :max="goods.stock*1"  :max="goodsSku[skuIndex].stock*1" -->
					<el-input-number @input="setNumber" class="flo_lf" size="mini" :precision="0" :max="999" :min="1" v-model="num4"></el-input-number>
					<!-- <el-input-number v-if="spce_type==2" class="flo_lf" size="mini" :precision="0" :min="1" v-model="num4"></el-input-number> -->
				</div>
				<div  class="goods_select clearfloat">
					<div class="goods_lie flo_lf">
						选择规格：
					</div>
					<div class="flo_lf zjid" >
						<div class="spec_btn" :class="{'langseas':skuIndex==i}"
						v-for="(item,i) in goodsSku" :key="item.id" @click="skuIndex =i;num4=1">{{item.attr_value}}</div>
					</div>
				</div>
				<div class="goods_select clearfloat">
					<div class="goods_lie flo_lf">
						价格：
					</div>
					<div class="flo_lf zjid">
						<!-- market_price:市场价	not_price:未登录价		sale_price:销售价-->
						<!-- <template v-if="goodsSku[skuIndex]&&spce_type==2"> -->
							<span class="pric" >
								
								<!-- 未登录的情况下 -->
								<template v-if="!user.id">
									¥<span v-if="goodsSku[skuIndex].not_price&&goodsSku[skuIndex].not_price!=0">{{goodsSku[skuIndex].not_price}}</span>
									<span v-else>{{goodsSku[skuIndex].market_price}}</span>
								</template>
								<!-- 登录的情况下 -->
								<template v-else>
									<span v-if="goodsSku[skuIndex].sale_price!=goodsSku[skuIndex].market_price && goodsSku[skuIndex].market_price" class="xiaos"> ¥{{goodsSku[skuIndex].market_price}}</span>
									<span>{{goodsSku[skuIndex].sale_price}}</span>
								</template>
							</span>
							<span class="wei">{{goodsSku[skuIndex].stock==1?'现货':'期货'}}</span>
						<!-- </template>
						<template v-if="spce_type==1">
							<span class="pric" >
								<span v-if="goods.market_price!=goods.sale_price&&goods.market_price" class="xiaos">¥{{goods.sale_price}}</span>
								¥<span v-if="!user.id&&goods.not_price">{{goods.not_price}}</span>
								<span v-else>{{goods.market_price}}</span>
							</span>
							<span class="wei">{{goods.stock==1?'现货':'期货'}}</span>
						</template> -->
						<span v-if="!user.id" class="zhuanx" >（会员请<span @click="goLogin" class="alik">登录</span>查看专享价！）</span>
					</div>
				</div>
				<div class="dinggo_goods clearfloat">
					<button v-preventReClick class="laing_btn flo_lf" @click="addOredr">订购</button>
					<button v-notClick="isTosub" class="addgwc flo_lf" @click="addgwc">加入购物车</button>
				</div>
				<div class="btn_asd">
					<div class="laing_btn" @click="goUrl(goods.btn1.category_1)" v-if="goods.btn1">
						<div>{{goods.btn1.title}}</div>
					</div>
					<div class="laing_btn" @click="goUrl(goods.btn2.category_1)" v-if="goods.btn2">
						<div>{{goods.btn2.title}}</div>
					</div>
					<!-- xin.goUrl('/oneDetails?cid='+goods.btn3.category_1) -->
					<div class="laing_btn" @click="goUrl(goods.btn3.category_1)" v-if="goods.btn3">
						<div>{{goods.btn3.title}}</div>
					</div>
				</div>
				<div v-if="goods.btn4" class="geako" @click="xin.goNew(goods.btn4.url)" >
					{{goods.btn4.title}}
				</div>
			</aside>
			<!-- 产品图片 -->
			<aside v-if="descriptionImg.length" class="goods_right flo_right">
				<div class="details_imgs" ref="box">
					<div @mouseenter="imgenter()" @mouseleave="imgleave" @mousemove="smalltop($event)" ref="smalls" class="small">
						<img :src="descriptionImg[imgIndex]" alt=""/>
						<div v-show="ismask" ref="mask"  class="mask"></div>
					</div>
					<div class="big" v-show="isbig">
						<img ref="bigimg" :src="descriptionImg[imgIndex]" alt=""/>
					</div>
				</div>
				<div class="img_selse">
					<div @mouseenter="enter(i)" class="sele" :class="{'sele_chon':i==imgIndex}"
					v-for="(item,i) in descriptionImg" :key="i">
						<img :src="item" alt="">
					</div>
				</div>
			</aside>
		</section>
		<section v-if="goods.video" class="goods_video">
			<video controls :src="goods.video">
				<h1>您的浏览器不支持H5video播放</h1>
			</video>
		</section>
		<!-- 产品内容 -->
		<nav class="goods_tabs clearfloat">
			<!-- <div class="spec_btn ">200tests</div> -->
			<div class="spec_btn langseas" v-for="(item,i) in goods.intr" :key="i"
			@click="gundoUrl(item.id+item.update_time)">{{item.title}}</div>
		</nav>
		<section class="goods_Dateil">
			<div v-for="(item) in goods.intr" :key="item.id" >
				<p class=" list_title" :id="item.id+item.update_time">{{item.title}}</p>
				<div v-html="item.content"></div>
			</div>
		</section>
		<section v-if="!loading" class="guanlian_goods">
			<p class="gui_title">关联产品</p>
			<div class="product_list">
				<article @click="xin.goUrl('/products/'+item.id)" class="pro_zi" v-for="item in associated" :key="item.id">
					<div class="pro_img">
						<img :src="item.cover_img" />
					</div>
					<div class="pro_title_zi">
						<div class="cur_po pro_title">{{item.title}}</div>
						<div class="geng">{{item.subtitle}}</div>
					</div>
				</article>
			</div>
		</section>
	</main>
</div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
	export default{
		data(){
			return {
				
				loading:true,
				isTosub:true,
				isval:false,
				associated:[],
				spce_type:0,
				category:{},//分类信息
				ismsg:true,//产品信息显示
				ismask:false,//遮罩
				isbig:false,//放大图片
				imgIndex:0,//图片索引
				skuIndex:0,//规格索引
				num4:1,//购买数量
				num:1,
				goods:{},//产品详情
				goodsSku:{},
				descriptionImg:[],//产品图片
			}
		},
		computed:{
			...mapState(['user','token','className','activeIndex','classifyList'])
		},
		watch:{
			$route(to,fo){
				this.PostGoodsinfo(to.params.id);
			}
		},
		created() {
			this.PostGoodsinfo(this.$route.params.id);
		},
		methods:{
			...mapActions(['setgoodsCount']),
			goLogin(){
				console.log("#$@#")
				this.$router.push({path:'/login',query: {
					redirect: '/products/'+this.goods.id    // 将跳转的路由path作为参数，登录成功后跳转到该路由
				}})
			},
			goUrl(id){
				if(id){
					this.xin.goUrl('/oneDetails?cid='+id);
				}
			},
			setNumber(str){
				if(!str){
					this.num4 = ' ';
				}
			},
			async addOredr(){//直接订购
				if(this.goods.stock<=0)this.$message({ message: '库存不足', type: 'warning' });
				else if(!this.user.id) this.xin.goUrl('/login?redirect=/products/'+this.$route.params.id)
				else{
					this.$router.push({name:'确认订单',params:{
						goods:[{ sku_id:this.goodsSku[this.skuIndex].id,number:this.num4}],
						is_cart:0
					}})
				}
			},
			async addgwc(){//加入购物车
				if(this.goods.stock<=0)this.$message({ message: '库存不足!', type: 'warning' });
				else if(this.user.id){
					this.isTosub = false;
					let {code} = await this.api.PostGoodsadd({ sku_id:this.goodsSku[this.skuIndex].id,number:this.num4})
					this.isTosub = true;
					if(code == 200)
						this.$message({ showClose: true, message: '添加成功', type: 'success' });
					this.setgoodsCount();//更新购物车数量
				}else this.xin.goUrl('/login?redirect=/products/'+this.$route.params.id)
			},
			enter(i){//tab图片移入
				this.imgIndex = i;
			},
			imgenter(i){//大图片移入
				this.ismask = true;
				this.isbig = true;
			},
			imgleave(){//大图片移出
				this.ismask = false;
				this.isbig = false;
			},
			gundoUrl(id){//滚动到指定位置
				window.scrollTo({
					top:this.heightTop(document.getElementById(id))-(window.screen.height/2),
					behavior:'smooth'
				})
			},
			heightTop(ele){
				//ele为指定跳转到该位置的DOM节点
				let root = document.body;
				let height = 0;
				do{
					height += ele.offsetTop;
					ele = ele.offsetParent;
				}while( ele !== root )
				return height;
			},
			smalltop(event){
				let small = this.$refs.smalls;
				let bigImg = this.$refs.bigimg;
				let box = this.$refs.box;
				let mask = this.$refs.mask;
				 //想要移动黄盒子，必须要知道鼠标在small小图中的位置。
                var pagex = event.pageX || this.scroll().left + event.clientX;
                var pagey = event.pageY || this.scroll().top + event.clientY;
                //x：mask的left值，y：mask的top值。
                var x = pagex - box.offsetLeft - mask.offsetWidth / 2; //除以2，可以保证鼠标mask的中间
                var y = pagey - box.offsetTop - mask.offsetHeight / 2;
                //限制换盒子的范围
                //left取值为大于0，小盒子的宽-mask的宽。
                if (x < 0) {
                    x = 0;
                }
                if (x > small.offsetWidth - mask.offsetWidth) {
                    x = small.offsetWidth - mask.offsetWidth;
                }
                //top同理。
                if (y < 0) {
                    y = 0;
                }
                if (y > small.offsetHeight - mask.offsetHeight) {
                    y = small.offsetHeight - mask.offsetHeight;
                }

                //移动黄盒子
                mask.style.left = x + "px";
                mask.style.top = y + "px";

                //3.右侧的大图片，等比例移动。
                //如何移动大图片？等比例移动。
                //    大图片/大盒子 = 小图片/mask盒子
                //    大图片走的距离/mask走的距离 = （大图片-大盒子）/（小图片-黄盒子）
//                var bili = (bigImg.offsetWidth-big.offsetWidth)/(small.offsetWidth-mask.offsetWidth);

                //大图片走的距离/mask盒子都的距离 = 大图片/小图片
                var bili = bigImg.offsetWidth / small.offsetWidth;
                var xx = bili * x;  //知道比例，就可以移动大图片了
				var yy = bili * y;
				
                bigImg.style.marginTop = -yy + "px";
                bigImg.style.marginLeft = -xx + "px";
			},
			async PostGoodsinfo(goods_id){//获取产品
				if(!goods_id){
					this.isval = true;
					return;
				}
				this.loading = true;
				let {data,code} = await this.api.PostGoodsinfo({goods_id,token:this.token});
				if(code==-40002)
					this.isval = true;
				else if(data.goods)
					data.goods.intr.sort((a,b)=>a.sort-b.sort);
				this.goods = data.goods||{};
				this.category = data.category||{};
				this.spce_type = data.goods.spce_type||{};
				this.goodsSku = data.goods_sku||{};
				this.descriptionImg = data.goods.description_img||{};
				this.associated = data.associated||{};
				this.loading = false;
			},
			scroll() {  // 开始封装自己的scrollTop
				if (window.pageYOffset != null) {  // ie9+ 高版本浏览器
					// 因为 window.pageYOffset 默认的是  0  所以这里需要判断
					return {
						left: window.pageXOffset,
						top: window.pageYOffset
					}
				}
				else if (document.compatMode === "CSS1Compat") {    // 标准浏览器   来判断有没有声明DTD
					return {
						left: document.documentElement.scrollLeft,
						top: document.documentElement.scrollTop
					}
				}
				return {   // 未声明 DTD
					left: document.body.scrollLeft,
					top: document.body.scrollTop
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
.htmlsss{
	/deep/p{
		margin: 0;
	}
}
.goods_Dateil{
	display: flex;
	flex-direction: column;
	/deep/ p{
	margin: 0;
	line-height: 2;
	}
	/deep/ table{
		// width: 100%!important;
	}
	/deep/ table,tr,th,td{
		line-height: 2;
	}
}

.to_backtop{
	box-shadow: 0 0 6px rgba(0,0,0,.12);
	width: 50px;
	height: 70px;
	background: #fff;
	color: var(--themeColor);
	line-height: 70px;
	text-align: center;
	border-radius: 10px;
	.el-icon-top{
		font-size: 26px;
	}
}
.list_title{
	text-decoration: underline;
	color:#af005f;
	font-weight: 600;
	font-size: 26px;
}
.goods_video{
	margin: 30px 0;
	video{
		width: 100%;
	}
}
	//关联产品
	.guanlian_goods{
		.product_list{
			.pro_zi{
				margin-top: 0px;
				width: 210px;
				.pro_img{
					width: 210px;
					height: 157px;
				}
			}
		}
		.gui_title{
			font-size: 24px;
			font-weight: 600;
			text-decoration: underline;
			color: #333333;
			line-height: 30px;
		}
	}
	.goods_tabs{
		// margin-top: 20px;
		position: sticky;
		top: 0;
		padding-top: 10px;
		background: #fff;
		z-index: 99;
		.spec_btn{
			float: left;
			margin-right: 10px;
			width: 175px;
			height: 50px;
			line-height: 50px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
	.goods_box{
		.goods_left{
			width: 660px;
			& > div{
				margin: 20px 0;
			}
			//概况
			.geako{
				background: #FF6F00;
				color: #fff;
				width: 500px;
				text-align: center;
				line-height: 50px;
				height: 50px;
				font-size: 20px;
				border-radius: 5px;
				cursor: pointer;
			}
			//推荐
			.btn_asd{
				display: flex;
				.laing_btn{
					background: #FFC000;
					margin: 0 20px 0 0;
					width: 153px;
					height: 50px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					line-height: 20px;
				}
			}
			//购买
			.dinggo_goods{

				.laing_btn{

				}
				.addgwc{
					margin-left: 20px;
					width: 180px;
					height: 40px;
					border-radius: 5px;
					text-align: center;
					line-height: 40px;
					color: #666;
					border: 1px solid #666666;
					cursor: pointer;
				}
			}
			//选择数量
			.goods_select{
				font-size: 16px;
				text-align: left;
				color: #8f8f8f;
				.pric{
					color: #B03130;
					line-height: 16px;
					font-size: 32px;
					.xiaos{
						color: #9b9b9b;
						font-size: 16px;
						text-decoration: line-through;
						margin-right: 10px;
					}
				}
				.goods_lie{
					width: 80px;
				}
			}
			.zjid{
				display: flex;
				flex-wrap: wrap;
				// width: 400px;
				color: #333;
				.wei{
					font-size: 18px;
					color: #333333;
					margin-left: 10px;
				}
				.zhuanx{
					font-weight: 600;
					font-size: 18px;
					color: #333333;
					.alik{
						color: #00aef3;
						text-decoration: underline;
						cursor: pointer;
					}
				}
			}
			//资料下载
			.goods_download{
				display: flex;
				// justify-content: space-around;
				flex-wrap: wrap;
				.goods_dow{
					border-radius: 4px;
					margin: 15px 20px 0  0 ;
					width: 155px;
					height: 40px;
					border: 1px solid #D9D9D9;
					text-align: center;
					line-height: 40px;
					cursor: pointer;
				}
			}
			// 基本参数
			.goods_list{
				p{
					
				}
				.goods_li{
					margin-bottom: 5px;
					color: #333333;
					font-size: 20px;
					display: flex;
					align-content: center;
					.li_left{
						color: #005599;
					}
					.w1{
						letter-spacing: 3px;
					}
				}
			}
			.goods_title{
				font-size: 26px;
				font-weight: 600;
				line-height: 30px;
				color: #333;
				width: 550px;
				// text-decoration: underline;
			}
			.goods_intro{
				font-size: 16px;
				font-weight: 500;
				color: #666666;
				line-height: 30px;
			}
		}
		.goods_right{
			width: 500px;
			.details_imgs{
				position: relative;
				.big {
					width: 500px;
					height: 375px;
					position: absolute;
					top: 0;
					left: -510px;
					border: 1px solid #ccc;
					overflow: hidden;
					// display: none;
					z-index: 99;
					img{
						vertical-align: top;
						width: 290%;
						height: 290%;
						// display: block;
					}
				}
				.small {
					position: relative;
					img{
						width: 500px;
						height: 375px;
						vertical-align: top;
					}
					 /*mask的中文是：遮罩*/
					.mask {
						width: 178px;
						height: 135px;
						background: rgba(255, 255, 0, 0.4);
						position: absolute;
						top: 0;
						left: 0;
						cursor: move;
						z-index: 10;
						// display: none;
					}
				}
			}
			.img_selse{
				margin-top: 20px;
				display: flex;
				.sele{
					margin-right: 20px;;
					img{
						width: 90px;
						height: 67px;
						display: block
					}
				}
				.sele_chon{
					border: 2px solid #f40;
				}
			}
		}
	}
	.langseas{
		background: #005599;
		color: #fff;
	}
	.spec_btn{
		border-radius: 4px;
		cursor: pointer;
		width: 100px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		margin: 0 10px 10px 0;
		border: 1px solid #8F8F8F;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
